import React, { useState, useEffect, lazy, Suspense } from "react";
import axios from "axios";
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import "@fontsource/poppins";
import "./App.css";
import Loader from "./components/Loader";
import Navbar from './components/PostEvent/Navbar';
import { CookieSetting } from "cookiesetting-component";
import jsonData from "./components/PostEvent/ai-branding.json"; // Import the JSON file

const Body = lazy(() => import(".././src/components/PostEvent/Body"));
const Footer = lazy(() => import("./components/Footer"));
const Video = lazy(() => import('./components/Video/Video.js'));
const PostEventMemories = lazy(() => import('../src/components/PostEvent/PostEventMemories.js'))
const Thankyou = lazy(() => import(".././src/components/PostEvent/Thankyou.js"));
const SubscribeForEventNotifications = lazy(() => import("../src/components/PostEvent/SubscribeForEventNotifications.js"));
const VideoHighlights = lazy(() => import("../src/components/PostEvent/VideoHighlights.js"));
const MemoriesHighlights = lazy(() => import("../src/components/PostEvent/MemoriesHighlight.js"));
const PostSocial = lazy(() => import("../src/components/PostEvent/PostSocial.js"));
const PostEventVideo = lazy(() => import("../src/components/PostEvent/PostEventVideos.js"));


function App() {
  const appVersion = appversion.version;
  const [videoToggle, setVideoToggle] = useState(false);
  const [played, setPlayed] = useState(false);
  const imgCDNURL = process.env.REACT_APP_POSTAMAZINGMORGAN_CDN_URL;

  const handleVideo = (videoToggle) => {
    setVideoToggle(!videoToggle);
    setPlayed(true);
  };
  const [links, setLinks] = useState(null);
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  return (
    <div className="bodyContainer">
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true}
        isVerboseMode={false} //If true, the library writes verbose logs to console.
        metaFileDirectory={'.'}
      >
        <img src={imgCDNURL + "topleftorangeshadow.png"} className="flower2 img-fluid"
          alt="Flower" />
        <img src={imgCDNURL + "upperdotted.png"} className="dot1" />
        <Suspense fallback={<div />}>
          <Navbar />
        </Suspense>
        <Suspense fallback={<div />}>
          <Body links={links} handleVideo={handleVideo} videoToggle={videoToggle} />
        </Suspense>
        <Suspense fallback={<div />}>
          <PostEventVideo handleVideo={handleVideo} videoToggle={videoToggle} />
        </Suspense>
        <Suspense fallback={<div />}>
          <PostEventMemories />
        </Suspense>
        <Suspense fallback={<div />}>
          <PostSocial handleVideo={handleVideo} videoToggle={videoToggle} />
        </Suspense>
        <Suspense fallback={<div />}>
          <Thankyou links={links} />
        </Suspense>
        <Suspense fallback={<div />}>
          <SubscribeForEventNotifications />
        </Suspense>
        <Suspense fallback={<div />}>
          <VideoHighlights />
        </Suspense>
        <Suspense fallback={<div />}>
          <MemoriesHighlights />
        </Suspense>
        <Suspense fallback={<div />}>
          <Footer />
        </Suspense>
        <CookieSetting 
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
        />
        <Suspense fallback={<Loader />}>
          {played && <Video handleVideo={handleVideo} videoToggle={videoToggle} />}
        </Suspense>
      </CacheBuster>
    </div>
  );
}

export default App;
